import axios from "axios"

export const getTokenByTicktAndCliant = async (tikite: any, cliantId: any) => {
  return await axios.post(`${process.env.REACT_APP_AUTHPATH}/exchangeToken`, {
    ticket: tikite,
    clientId: cliantId ? cliantId : '09f60950-6c2f-4283-a67f-2719ef5cf32e'
  })
}